export default __webpack_public_path__ + "static/media/not-left.8acbd024.svg";